import {deserialize} from 'libs/cerialize';

export default class Exception {
	@deserialize
	Message: string;
} 